var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartedecredit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 40,
    viewBox: "0 0 51 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 20.0062C49 11.3362 49 7.0001 46.2458 4.30784C43.4939 1.61328 39.0618 1.61328 30.2 1.61328H20.8C11.9381 1.61328 7.50605 1.61328 4.7542 4.30784C2 7.0001 2 11.3362 2 20.0062C2 28.6761 2 33.0123 4.7542 35.7045C7.50605 38.3991 11.9381 38.3991 20.8 38.3991H30.2C39.0618 38.3991 43.4939 38.3991 46.2458 35.7045C47.7827 34.2032 48.4618 32.1915 48.7603 29.2026M20.8 29.2026H11.4M30.2 29.2026H26.675M2 15.408H13.75M49 15.408H23.15",
    stroke: "#003F6D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartedecredit);
export default __webpack_public_path__ + "static/media/carte de crédit.056f75e5fb63f47e32f3d0ac6933c742.svg";
export { ForwardRef as ReactComponent };